import { Component, signal } from '@angular/core';
import { AccountsComponent } from '../../admin/organizations/components/soar-rules/components/accounts/accounts.component';
import { BulletinComponent } from '../../admin/organizations/components/soar-rules/components/bulletin/bulletin.component';
import { ServerComponent } from '../../admin/organizations/components/soar-rules/components/server/server.component';
import { TravelAdvisoriesComponent } from '../../admin/organizations/components/soar-rules/components/travel-advisories/travel-advisories.component';
import { VulnerabilityComponent } from '../../admin/organizations/components/soar-rules/components/vulnerability/vulnerability.component';
import { PageTabsComponent, PageTab } from '../../../core/components/page-tabs/page-tabs.component';

@Component({
  selector: 'app-soc-tuning',
  standalone: true,
  imports: [AccountsComponent, BulletinComponent, ServerComponent, TravelAdvisoriesComponent, VulnerabilityComponent, PageTabsComponent],
  templateUrl: './soc-tuning.page.html',
  styleUrl: './soc-tuning.page.scss',
})
export class SocTuningPage {
  public activeTab = signal<string>('travel-advisories');

  public tabs: PageTab[] = [
    { id: 'travel-advisories', label: 'Travel Advisories' },
    { id: 'service-accounts', label: 'Service Accounts' },
    { id: 'vulnerability-scanners', label: 'Vulnerability Scanners' },
    { id: 'server-exceptions', label: 'Server Exceptions' },
    { id: 'soc-bulletins', label: 'SOC Bulletins' },
  ];
}
